import { LeftOutlined } from '@ant-design/icons';
import { Col, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './NotiDetail.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useSelector } from 'react-redux';
import notificationAPI from '~/api/NotificationAPI';

const cx = classNames.bind(styles);

const NotiDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { post_id } = useParams();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';

    const [isLoading, setIsLoading] = useState(false);

    const [postInfo, setPostInfo] = useState({});

    const handleGetPost = async () => {
        setIsLoading(true);
        try {
            const params = {
                fields: '["$all"]',
            };
            const res = await notificationAPI.getNotificationAPI(post_id, params);
            if (res.code === 200) {
                console.log('Khiem info', res?.results?.object);
                setPostInfo(res?.results?.object);
            }
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        console.log('Khiem post', post_id);
        handleGetPost();
        // eslint-disable-next-line
    }, [post_id]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangChiTietThongBao');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {postInfo?.id ? (
                        <div className={cx('container')}>
                            <div className={cx('right_section')}>
                                <Row className={cx('name_page')}>
                                    <LeftOutlined onClick={() => navigate(-1)} />{' '}
                                    <Col className={cx('name_page_title')}>Notification</Col>
                                </Row>
                                <div className={cx('right_container')}>
                                    <Row className={cx('tutorial_content')}>
                                        <div className={cx('title')}>{postInfo?.message_title}</div>
                                        <div className={cx('content')}>{postInfo?.message_content}</div>
                                        {/* <div dangerouslySetInnerHTML={{ __html: postInfo.description }}></div> */}
                                    </Row>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Row justify="center" align="middle" className={cx('card_no_exist')}>
                            Notification does not exist
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default NotiDetail;
